import React from 'react';
import { useTranslation } from 'react-i18next';
import VerticalNav from 'components/v2/navs/VerticalNav';
export function YardNav({ activeTab, id }) {
    const yardLink = `/yards/${id}`;
    const isNewYard = id === 'new';
    const { t } = useTranslation();
    return (React.createElement(VerticalNav, null,
        React.createElement(VerticalNav.NavItem, { id: "yardDetailsTab", url: yardLink, active: activeTab === 'yard' }, t('YARD_DETAILS')),
        !isNewYard && (React.createElement(VerticalNav.NavItem, { id: "marketRatesTab", url: `${yardLink}/rates`, active: activeTab === 'rates' }, t('MARKET_RATE_other', { count: 3 })))));
}
